import { api } from "@/lib/api";

const STORE = "mango.transfers";

export const savedTransfers = () => { try { return JSON.parse(localStorage.getItem(STORE) || "[]"); } catch { return []; } };
export const saveTransfers = (list) => localStorage.setItem(STORE, JSON.stringify(list));

export async function fetchActivity() {
  const list = savedTransfers();
  if (!list.length) return {};
  const { data } = await api.post("/transfers/activity", { transfers: list.map(({ id, key }) => ({ id, key })) });
  return Object.fromEntries(data.map((a) => [a.id, { ...a, unseen: Math.max(0, a.downloads - (list.find((h) => h.id === a.id)?.seen || 0)) }]));
}

export function markSeen(activity) {
  saveTransfers(savedTransfers().map((h) => (activity[h.id] ? { ...h, seen: activity[h.id].downloads } : h)));
}

export const timeAgo = (iso) => {
  const s = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86400)} d ago`;
};
